import { useMemo } from 'react'
import { Card, CardBody, Col, Input } from 'reactstrap'

import { List, CustomButton } from 'components/common'
import type { ListItem, FilterItem } from 'components/common/types'

import placeholder from 'images/allEmpty.svg'

import WorkerFilter from './WorkerFilter'

import styles from './WorkerList.module.scss'

import type { ChangeEvent, KeyboardEvent, UIEvent } from 'react'

type WorkerListPanelProps = {
  listItems: ListItem[]
  selectedId?: number
  filterItems: FilterItem[]
  filterWord: string
  disabledSearchButton: boolean
  onSearchInput: (event: ChangeEvent<HTMLInputElement>) => void
  onFilterChange: (items: FilterItem[]) => void
  onSearch: () => void
  onClearFilter: () => void
  onSelectWorker: (workerId: string | number) => void
  onScroll: (e: UIEvent<HTMLDivElement>) => void
  emptyMessage?: string
  emptyDescription?: string
}

export const WorkerListPanel = ({
  listItems,
  selectedId,
  filterItems,
  filterWord,
  disabledSearchButton,
  onSearchInput,
  onFilterChange,
  onSearch,
  onClearFilter,
  onSelectWorker,
  onScroll,
  emptyMessage = 'メンバーがいません',
  emptyDescription = 'メンバーを追加して、詳細情報を編集しましょう。',
}: WorkerListPanelProps) => {
  const hasListItems = useMemo(() => listItems.length > 0, [listItems])

  return (
    <Col md={4} className="h-100">
      <Card className={`position-sticky h-100 ${styles.list}`} onScroll={onScroll}>
        <div className="d-flex">
          <div className="position-relative w-100">
            <Input
              placeholder="メンバー名もしくは識別子で検索"
              value={filterWord}
              onChange={onSearchInput}
              onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => e.key === 'Enter' && onSearch()}
            />
            {filterWord && (
              <span
                role="button"
                className={
                  'text-primary text-decoration-underline position-absolute top-50 translate-middle-y end-0 pe-3'
                }
                onClick={onClearFilter}
              >
                クリア
              </span>
            )}
          </div>
          <div className="ms-2">
            <WorkerFilter filterItems={filterItems} onChange={onFilterChange} />
          </div>
          <CustomButton className="ms-2 text-nowrap" onClick={onSearch} disabled={disabledSearchButton}>
            検索
          </CustomButton>
        </div>
        {hasListItems ? (
          <List items={listItems} selectedId={selectedId} onAction={onSelectWorker} />
        ) : (
          <CardBody className="d-flex align-items-center justify-content-center">
            <div className="text-center">
              <img className={`mx-auto d-block w-100 ${styles.placeholderImage}`} src={placeholder} alt="" />
              <div className="font-middle fw-bold py-4">{emptyMessage}</div>
              <div>{emptyDescription}</div>
            </div>
          </CardBody>
        )}
      </Card>
    </Col>
  )
}
